var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiCheckCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8332 23.0834V25C45.8306 29.4926 44.3759 33.864 41.6859 37.4622C38.996 41.0604 35.215 43.6927 30.9068 44.9665C26.5987 46.2403 21.9941 46.0873 17.78 44.5304C13.5658 42.9735 9.96787 40.0961 7.52267 36.3273C5.07748 32.5585 3.91607 28.1002 4.21166 23.6174C4.50726 19.1346 6.24402 14.8674 9.16292 11.4523C12.0818 8.03717 16.0265 5.65709 20.4086 4.66701C24.7907 3.67694 29.3754 4.12991 33.479 5.95838",
    stroke: "url(#paint0_linear_1656_8904)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8333 8.33325L25 29.1874L18.75 22.9374",
    stroke: "url(#paint1_linear_1656_8904)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1656_8904",
    x1: 45.8332,
    y1: 24.9881,
    x2: 4.1665,
    y2: 24.9881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CBA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1656_8904",
    x1: 45.8333,
    y1: 18.7603,
    x2: 18.75,
    y2: 18.7603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CBA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiCheckCircle);
export default __webpack_public_path__ + "static/media/fi_check-circle.694ce14d3dc17584ecab4fc4d26753dd.svg";
export { ForwardRef as ReactComponent };